import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/pages/conversation/assets/images/chevron-up.svg'
import _imports_1 from '@/pages/conversation/assets/images/chevron-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-f5a2d244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1
}
const _hoisted_6 = { class: "filter-title" }
const _hoisted_7 = { class: "filter-value" }
const _hoisted_8 = { class: "horizontal-scroll-container" }
const _hoisted_9 = { class: "filter-title" }
const _hoisted_10 = { class: "filter-value" }
const _hoisted_11 = { class: "horizontal-scroll-container" }
const _hoisted_12 = { class: "reset-filters-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "filter-divider" }, null, -1))
const _hoisted_14 = { class: "horizontal-scroll-container metrics-container" }
const _hoisted_15 = {
  key: 0,
  class: "scrolling-item"
}
const _hoisted_16 = {
  key: 1,
  class: "scrolling-item"
}
const _hoisted_17 = {
  key: 2,
  class: "scrolling-item"
}
const _hoisted_18 = {
  key: 3,
  class: "scrolling-item"
}
const _hoisted_19 = {
  key: 4,
  class: "scrolling-item"
}
const _hoisted_20 = {
  key: 5,
  class: "scrolling-item"
}
const _hoisted_21 = {
  key: 0,
  class: "not-available"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-title" }, "Not available", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, " Contact Support about tracking your Repeat Customers ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, " NPS scores are categorised into 3 different statuses: Gold, Silver and Bronze. ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, " These help you identify who are your high and low performers. The statuses are based on the range of NPS scores across the entire group. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TwoLineHeader = _resolveComponent("TwoLineHeader")!
  const _component_InsightsTimePickerMobile = _resolveComponent("InsightsTimePickerMobile")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PillButton = _resolveComponent("PillButton")!
  const _component_VueSlideUpDown = _resolveComponent("VueSlideUpDown")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_StatusPillButton = _resolveComponent("StatusPillButton")!
  const _component_InsightsMetric = _resolveComponent("InsightsMetric")!
  const _component_InsightsTable = _resolveComponent("InsightsTable")!
  const _component_GradientHighlightedCard = _resolveComponent("GradientHighlightedCard")!
  const _component_Scrollable = _resolveComponent("Scrollable")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    "no-pad": "",
    class: "insights",
    "show-go-back": true,
    "disable-when-offline": ""
  }, {
    "custom-title": _withCtx(() => [
      _createVNode(_component_TwoLineHeader, {
        title: "Growth",
        subtitle: _ctx.friendlyTimeRange
      }, null, 8, ["subtitle"])
    ]),
    "right-button": _withCtx(() => [
      _createVNode(_component_InsightsTimePickerMobile, {
        "time-range": _ctx.timeRange,
        onSelectTime: _ctx.updateTimeRange
      }, null, 8, ["time-range", "onSelectTime"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Scrollable, {
        loading: _ctx.isLoadingInsightsData,
        "pull-down": _ctx.onPullDown
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1),
            _createVNode(_component_RouterLink, { to: { name: 'insightsDetail' } }, {
              default: _withCtx(() => [
                (_ctx.insightsDetails)
                  ? (_openBlock(), _createBlock(_component_BaseButton, {
                      key: 0,
                      primary: "",
                      small: "",
                      class: "primary-action"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("View Insights ")
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "caret",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilterVisibility && _ctx.toggleFilterVisibility(...args)))
            }, [
              (_ctx.showFilters)
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(" View " + _toDisplayString(_ctx.name) + " by ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.viewByGroupTypeName), 1)
            ]),
            _createVNode(_component_VueSlideUpDown, {
              active: _ctx.showFilters,
              duration: 250
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamHierarchy, (group, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "scrolling-item"
                    }, [
                      _createVNode(_component_PillButton, {
                        label: group.groupName,
                        "is-active": _ctx.getIsActive(group?.fieldMapping),
                        disabled: index <= _ctx.currentGroupLevel,
                        onClick: ($event: any) => (_ctx.setActiveDataType(index))
                      }, null, 8, ["label", "is-active", "disabled", "onClick"])
                    ]))
                  }), 128))
                ])
              ], undefined, true),
              _: 1
            }, 8, ["active"]),
            _createVNode(_component_VueSlideUpDown, {
              active: _ctx.showStatusFilterTitle,
              duration: 250
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(" Filter " + _toDisplayString(_ctx.pluralizedViewByGroupTypeName) + " that are ", 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedSelectedStatuses), 1),
                  _createVNode(_component_FontAwesomeIcon, {
                    icon: _ctx.faInfoCircle,
                    size: "lg",
                    onClick: _ctx.showModal
                  }, null, 8, ["icon", "onClick"])
                ])
              ], undefined, true),
              _: 1
            }, 8, ["active"]),
            _createVNode(_component_VueSlideUpDown, {
              active: _ctx.showFilters,
              duration: 250
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OrderedInsightsStatuses, (status) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: status,
                      class: "scrolling-item"
                    }, [
                      _createVNode(_component_StatusPillButton, {
                        status: status,
                        label: status,
                        "is-active": _ctx.selectedStatuses[status],
                        onClick: ($event: any) => (_ctx.toggleStatus(status))
                      }, null, 8, ["status", "label", "is-active", "onClick"])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "reset-filters",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                  }, " Reset Filters ")
                ])
              ], undefined, true),
              _: 1
            }, 8, ["active"]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.activeMetrics.includes('nps'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_InsightsMetric, {
                    active: _ctx.selectedMetric === _ctx.InsightsMetrics.NPS,
                    delta: _ctx.isNpsChangePositive ? 'positive' : 'negative',
                    title: _ctx.nps,
                    subtitle: _ctx.InsightsMetrics.NPS,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickMetric(_ctx.InsightsMetrics.NPS, 'nps')))
                  }, null, 8, ["active", "delta", "title", "subtitle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showCsatTile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_InsightsMetric, {
                    active: _ctx.selectedMetric === _ctx.InsightsMetrics.CSAT,
                    delta: _ctx.isCsatChangePositive ? 'positive' : 'negative',
                    title: _ctx.csatRating,
                    subtitle: _ctx.InsightsMetrics.CSAT,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickMetric(_ctx.InsightsMetrics.CSAT, 'csat')))
                  }, null, 8, ["active", "delta", "title", "subtitle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showFivestarTile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_InsightsMetric, {
                    active: _ctx.selectedMetric === _ctx.InsightsMetrics.FIVESTAR,
                    delta: 
                            _ctx.isFivestarChangePositive ? 'positive' : 'negative'
                        ,
                    title: _ctx.fivestarRating,
                    subtitle: _ctx.InsightsMetrics.FIVESTAR,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.onClickMetric(_ctx.InsightsMetrics.FIVESTAR, 'fivestar')
                        ))
                  }, null, 8, ["active", "delta", "title", "subtitle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.repeatCustomerMetricEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.isRepeatVisitTrackingConfigured)
                    ? (_openBlock(), _createBlock(_component_InsightsMetric, {
                        key: 0,
                        active: 
                            _ctx.selectedMetric === _ctx.InsightsMetrics.REPEAT_VISIT
                        ,
                        delta: 
                            _ctx.isRepeatVisitChangePositive
                                ? 'positive'
                                : 'negative'
                        ,
                        title: `${_ctx.repeatCustomer}%`,
                        subtitle: _ctx.InsightsMetrics.REPEAT_VISIT,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClickMetric(_ctx.InsightsMetrics.REPEAT_VISIT)))
                      }, null, 8, ["active", "delta", "title", "subtitle"]))
                    : (_openBlock(), _createBlock(_component_InsightsMetric, {
                        key: 1,
                        active: 
                            _ctx.selectedMetric === _ctx.InsightsMetrics.REPEAT_VISIT
                        ,
                        title: "😤",
                        subtitle: _ctx.InsightsMetrics.REPEAT_VISIT,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClickMetric(_ctx.InsightsMetrics.REPEAT_VISIT)))
                      }, null, 8, ["active", "subtitle"]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.customerRetentionEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_InsightsMetric, {
                    active: _ctx.selectedMetric === _ctx.InsightsMetrics.RETENTION,
                    delta: 
                            _ctx.isCustomRetentionChangePositive
                                ? 'positive'
                                : 'negative'
                        ,
                    title: `${_ctx.customerRetention}%`,
                    subtitle: _ctx.InsightsMetrics.RETENTION,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClickMetric(_ctx.InsightsMetrics.RETENTION)))
                  }, null, 8, ["active", "delta", "title", "subtitle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.customerTenureEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_InsightsMetric, {
                    active: _ctx.selectedMetric === _ctx.InsightsMetrics.TENURE,
                    delta: 
                            _ctx.isCustomTenureChangePositive
                                ? 'positive'
                                : 'negative'
                        ,
                    title: `${_ctx.customerTenure}`,
                    subtitle: _ctx.InsightsMetrics.TENURE,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClickMetric(_ctx.InsightsMetrics.TENURE)))
                  }, null, 8, ["active", "delta", "title", "subtitle"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_GradientHighlightedCard, { class: "insights-table" }, {
            default: _withCtx(() => [
              (
                        _ctx.selectedMetric === _ctx.InsightsMetrics.REPEAT_VISIT &&
                        !_ctx.isRepeatVisitTrackingConfigured
                    )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _createVNode(_component_BaseButton, {
                      primary: "",
                      small: "",
                      class: "contact-support-button",
                      click: _ctx.onClickContactSupport
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Contact Support")
                      ], undefined, true),
                      _: 1
                    }, 8, ["click"])
                  ]))
                : (_openBlock(), _createBlock(_component_InsightsTable, {
                    key: 1,
                    name: _ctx.name,
                    "view-by-group-type-name": _ctx.viewByGroupTypeName,
                    "pluralized-view-by-group-type-name": 
                        _ctx.pluralizedViewByGroupTypeName
                    ,
                    "previous-group-name": _ctx.previousGroupName,
                    "team-scoreboard-groups": _ctx.teamScoreboardGroups,
                    "repeat-visits-groups": _ctx.repeatVisitsGroups,
                    statuses: _ctx.currentStatuses,
                    "selected-statuses": _ctx.selectedStatuses,
                    "is-leaf": _ctx.viewByGroupTypeIsLeafLevel,
                    "is-root": _ctx.isCurrentRootLevel,
                    "selected-metric": _ctx.selectedMetric,
                    "is-loading-insights-data": _ctx.isLoadingInsightsData,
                    onBack: _ctx.onUpOneLevel,
                    onDrilldown: _ctx.onDrillDown
                  }, null, 8, ["name", "view-by-group-type-name", "pluralized-view-by-group-type-name", "previous-group-name", "team-scoreboard-groups", "repeat-visits-groups", "statuses", "selected-statuses", "is-leaf", "is-root", "selected-metric", "is-loading-insights-data", "onBack", "onDrilldown"]))
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }, 8, ["loading", "pull-down"]),
      _createVNode(_component_Modal, {
        show: _ctx.isTooltipModalVisible,
        "allow-click-out": "",
        "allow-escape": "",
        title: "What is this?",
        size: "medium",
        close: () => (_ctx.isTooltipModalVisible = false)
      }, {
        default: _withCtx(() => [
          _hoisted_24,
          _hoisted_25
        ], undefined, true),
        _: 1
      }, 8, ["show", "close"])
    ], undefined, true),
    _: 1
  }))
}